import React from 'react';
import { Radio, Typography } from 'antd';

const { Text } = Typography;

interface CustomRadioProps {
  title: string;
  selected: boolean;
  onSelect: () => void;
  className?: string;
  size?: 'default' | 'small';
}

const CustomRadio: React.FC<CustomRadioProps> = ({
  title,
  selected,
  onSelect,
  className,
  size = 'default',
}) => {
  const sizeClasses =
    size === 'small'
      ? 'h-[36px] rounded-lg px-2 gap-1 text-sm'
      : 'h-[54px] rounded-[10px] px-4 text-lg leading-[20.88px] uppercase';

  return (
    <Radio
      checked={selected}
      onChange={onSelect}
      className={`custom-radio-small font-bold flex items-center cursor-pointer ${sizeClasses} ${
        selected
          ? 'text-customTunaPrimary bg-customYellowPrimary border border-solid border-customTunaPrimary'
          : 'text-customGrayShade5 bg-transparent border border-solid border-customGrayShade4'
      } ${className ?? ''} `}
    >
      <Text className='whitespace-nowrap'>{title}</Text>
    </Radio>
  );
};

export default CustomRadio;
